import {
  call,
  takeLatest,
  put,
} from 'redux-saga/effects';
import { clientRequestFailure, updateClient } from '../client';
import { CLIENT_FETCH } from '../actionTypes';
import api from '../../utils/services';

export function* getClientDetails() {
  try {
    const data = yield call(api.currentClient);
    yield put(updateClient(data.name));
  } catch (error) {
    yield put(clientRequestFailure(error));
  }
}

export default function* clientInfoSaga() {
  yield takeLatest(CLIENT_FETCH, getClientDetails);
}
